module.exports = __webpack_public_path__ + "static/media/strongher17_preview.7f4a351e.jpg";